function __variableDynamicImportRuntime6__(path) {
  switch (path) {

    default: return new Promise(function(resolve, reject) {
      (typeof queueMicrotask === 'function' ? queueMicrotask : setTimeout)(
        reject.bind(null, new Error("Unknown variable dynamic import: " + path))
      );
    })
   }
 }

function __variableDynamicImportRuntime5__(path) {
  switch (path) {

    default: return new Promise(function(resolve, reject) {
      (typeof queueMicrotask === 'function' ? queueMicrotask : setTimeout)(
        reject.bind(null, new Error("Unknown variable dynamic import: " + path))
      );
    })
   }
 }

function __variableDynamicImportRuntime4__(path) {
  switch (path) {

    default: return new Promise(function(resolve, reject) {
      (typeof queueMicrotask === 'function' ? queueMicrotask : setTimeout)(
        reject.bind(null, new Error("Unknown variable dynamic import: " + path))
      );
    })
   }
 }

function __variableDynamicImportRuntime3__(path) {
  switch (path) {

    default: return new Promise(function(resolve, reject) {
      (typeof queueMicrotask === 'function' ? queueMicrotask : setTimeout)(
        reject.bind(null, new Error("Unknown variable dynamic import: " + path))
      );
    })
   }
 }

function __variableDynamicImportRuntime2__(path) {
  switch (path) {

    default: return new Promise(function(resolve, reject) {
      (typeof queueMicrotask === 'function' ? queueMicrotask : setTimeout)(
        reject.bind(null, new Error("Unknown variable dynamic import: " + path))
      );
    })
   }
 }

function __variableDynamicImportRuntime1__(path) {
  switch (path) {
    case '../langs/en/about.md': return import('./about-ydHxRAah.js');
    case '../langs/en/api.md': return import('./api-BPMyZ3-k.js');
    default: return new Promise(function(resolve, reject) {
      (typeof queueMicrotask === 'function' ? queueMicrotask : setTimeout)(
        reject.bind(null, new Error("Unknown variable dynamic import: " + path))
      );
    })
   }
 }

function __variableDynamicImportRuntime0__(path) {
  switch (path) {

    default: return new Promise(function(resolve, reject) {
      (typeof queueMicrotask === 'function' ? queueMicrotask : setTimeout)(
        reject.bind(null, new Error("Unknown variable dynamic import: " + path))
      );
    })
   }
 }

function noThrow(x) {
    return x.catch(() => undefined);
}
async function getApi(lang) {
    return await noThrow(__variableDynamicImportRuntime0__(`../langs/${lang}/api/api.md`));
}
async function getDoc(lang, resource) {
    return await noThrow(__variableDynamicImportRuntime1__(`../langs/${lang}/${resource}.md`));
}
async function getGuideDirectory(lang) {
    const directory = await noThrow(__variableDynamicImportRuntime2__(`../langs/${lang}/guides/directory.json`));
    return directory?.default;
}
async function getTutorial(lang, lesson) {
    const [lessonFiles, solved, markdown] = await Promise.all([
        noThrow(__variableDynamicImportRuntime3__(`../langs/${lang}/tutorials/${lesson}/lesson.json`)),
        noThrow(__variableDynamicImportRuntime4__(`../langs/${lang}/tutorials/${lesson}/solved.json`)),
        noThrow(__variableDynamicImportRuntime5__(`../langs/${lang}/tutorials/${lesson}/lesson.md`)),
    ]);
    return {
        lesson: lessonFiles?.default,
        solved: solved?.default,
        markdown: markdown?.default,
    };
}
async function getTutorialDirectory(lang) {
    const directory = await noThrow(__variableDynamicImportRuntime6__(`../langs/${lang}/tutorials/directory.json`));
    return directory?.default;
}

export { getApi, getDoc, getGuideDirectory, getTutorial, getTutorialDirectory };
//# sourceMappingURL=index.js.map
